import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-favorite",
  "use": "icon-favorite-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol viewBox=\"0 0 90 90\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-favorite\">\r\n    <path d=\"M10,30 A20,20,0,0,1,50,30 A20,20,0,0,1,90,30 Q90,60,50,90 Q10,60,10,30 Z\" fill=\"red\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol